export default __webpack_public_path__ + "static/media/table-occupied.e96a5364.svg";